import * as actionTypes from "../actionTypes/actionTypes";
import {
  getCurrencyService,
  createNewCurrencyService,
  updateCurrencyService,
  deleteCurrencyService
  } from "../services/CurrencyService";
import * as _ from "lodash";
const getCurrencies = () => {
    return async(dispatch) => {
        dispatch({
            type: actionTypes.GET_CURRENCY
        })
        window.startLoading();
        getCurrencyService()
        .then((response)=>{
          const data = response.data;
          const sortedCurrency = _.sortBy(data, ['currencyName']);
            dispatch({
                type: actionTypes.GET_CURRENCY_SUCCESS,
                payload: sortedCurrency
            })
        })
        .catch((error)=>{
          dispatch({
            type: actionTypes.GET_CURRENCY_FAILURE,
            payload: error
        })
        }).finally(()=>{
          window.stopLoading();
        })
    }
}


const createNewCurrency = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CREATE_NEW_CURRENCY,
    });
    window.startLoading();
    await createNewCurrencyService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.CREATE_NEW_CURRENCY_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_NEW_CURRENCY_FAILURE,
          payload: error,
        });
      }).finally(()=>{
        window.stopLoading();
      })
  };
};

const updateCurrency = (currencyId,requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_CURRENCY,
    });
    window.startLoading();
    await updateCurrencyService(currencyId, requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.UPDATE_CURRENCY_SUCCESS,
          payload: data,
          currencyId: currencyId
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_CURRENCY_FAILURE,
          payload: error,
        });
      })
      .finally(() => {
        window.stopLoading();
      });
  };
};

const deleteCurrency = (requestPayload) => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.DELETE_CURRENCY
      })
      window.startLoading();
      await deleteCurrencyService(requestPayload)
      .then((response) => {
          const data = response.status;
          dispatch({
              type: actionTypes.DELETE_CURRENCY_SUCCESS,
              payload: data
          })
      })
      .catch((error) => {
          dispatch({
              type: actionTypes.DELETE_CURRENCY_FAILURE,
              payload: error
          })
      }).finally(()=>{
        window.stopLoading();
      });
  }
}

export { getCurrencies, createNewCurrency, updateCurrency, deleteCurrency };
